import {
  FEATURE_FLAGS,
  useFeatureFlags,
} from "@hl/shared-features/lib/features/auth/hooks";
import { useSupportedChains } from "@hl/shared-features/lib/features/chain";

const useEnableCategoriesAndTagsInput = (chainId: string) => {
  const enableCategoriesAndTags = useFeatureFlags(
    FEATURE_FLAGS.ENABLE_TAGS_AND_CATEGORIES
  );
  const enableCategoriesAndTagsInTestnet = useFeatureFlags(
    FEATURE_FLAGS.ENABLE_TAGS_AND_CATEGORIES_FOR_TESTNET
  );

  const { supportedChains } = useSupportedChains(!enableCategoriesAndTags);
  const chain = supportedChains.find(
    (chain) => chain.chainId.toString() === chainId
  );

  const isMainnet = chain && !chain.testnet;

  return (
    enableCategoriesAndTags && (enableCategoriesAndTagsInTestnet || isMainnet)
  );
};

export default useEnableCategoriesAndTagsInput;
